module.exports = __webpack_public_path__ + "static/scout-4b0a42ffca77e3e9d4a2080912b68987.jpeg";